
<div class="container mx-auto" style="margin-top: 5px;">
  <button type="button" class="btn btn-primary btn-sm"  onclick="history.back()">
    Back
  </button>
</div>